import React, { useEffect, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import Btn from "components/Custom/Btn";
import Loader from "components/Custom/Loader";
import RadioBtn from "components/Custom/RadioBtn";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";

import { NOTIFY, DEFAULTS } from "common/config";
import {
  WARNINGS,
  SUCCESS,
  LABELS,
  ERRORS,
  TITLES,
  SUB_TITLES,
} from "common/labels";
import { COLORS } from "common/colors";
import { COMMON_JS } from "common/scripts";

import { ApiMasters } from "apihandlers//masters/masters";

const ApiMastersHandler = new ApiMasters();

const TempRange = (props: any) => {
  const { setDashMenu } = props;
  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await ApiMastersHandler.getTempRanges(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getTempRanges:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
      headerAlign: "center",
    },
    {
      key: "tempRangeName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.NAME,
      width: "30%",
    },
    {
      key: "lowTemp",
      editable: false,
      sortable: true,
      type: "number",
      searchable: true,
      name: LABELS.LOW,
      width: "25%",
    },
    {
      key: "highTemp",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.HIGH,
      width: "25%",
    },
    {
      key: "activeStatusText",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ACTIVE,
      width: "10%",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageRecord = () => {
    const tempRangeName = (
      document.getElementById("tempRangeName") as HTMLInputElement
    ).value.trim();
    const lowTemp = (
      document.getElementById("lowTemp") as HTMLInputElement
    ).value.trim();
    const highTemp = (
      document.getElementById("highTemp") as HTMLInputElement
    ).value.trim();
    const active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const selectBtnValue = active ? active.value : "";

    // Validations
    if (!lowTemp) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
      return;
    }
    if (!highTemp) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
      return;
    }
    if (!tempRangeName) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
      return;
    }
    if (!selectBtnValue) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      tempRangeName,
      lowTemp,
      highTemp,
      activeStatus: selectBtnValue.toString(),
    };
    setIsSubmit(true);
    ApiMastersHandler.manageTempRange(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };
  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  // console.log("Users: ", loading, selectedRow.active);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.TEMP_RANGE}</li>
        </ul>
        <h4>{TITLES.TEMP_RANGE}</h4>
        <p className="SubTitles">{SUB_TITLES.TEMP_RANGE}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.TEMP_RANGE}
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.TEMP_RANGE}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.TEMP_RANGE + " : " + selectedRow.tempRangeName
              : "Add New " + LABELS.TEMP_RANGE
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
          }}
        >
          <div className="formGroup red">
            <TxtRow
              id={"tempRangeName"}
              label={LABELS.NAME}
              required={true}
              defaultValue={selectedRow.tempRangeName}
              disabled={isSubmit}
            />
          </div>
          <div className="flexRowJustify">
            <div className="formGroup width45 red">
              <TxtRow
                id={"lowTemp"}
                type={"number"}
                label={LABELS.LOW}
                required={true}
                defaultValue={selectedRow.lowTemp}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width45 red">
              <TxtRow
                id={"highTemp"}
                type={"number"}
                label={LABELS.HIGH}
                required={true}
                defaultValue={selectedRow.highTemp}
                disabled={isSubmit}
              />
            </div>
          </div>
          <div className="formGroup red">
            <label>
              {LABELS.ACTIVE_STATUS} {<span className="red">*</span>}
            </label>
            <RadioBtn
              list={[
                {
                  id: "activeYes",
                  value: "true",
                  label: LABELS.ACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === true
                    : true,
                  disabled: false,
                },
                {
                  id: "activeNo",
                  value: "false",
                  label: LABELS.INACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup submitBtnWrapper">
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => setManageDialog(false)}
                // loading={isSubmit}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageRecord}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(TempRange);
